// RetroTelevision.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Outlet, Link } from "react-router-dom";
import "./RetroTelevision.css";
import logo from "../logo2.png";

export default function RetroTelevision() {
  const [powerOn, setPowerOn] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [flicker, setFlicker] = useState(false);
  const hasRedirected = useRef(false);

  // On mobile, default to bio page instead of home (only on initial load)
  useEffect(() => {
    if (hasRedirected.current) return;
    const isMobile = window.innerWidth < 768;
    if (isMobile && location.pathname === "/") {
      hasRedirected.current = true;
      navigate("/bio", { replace: true });
    }
  }, [location.pathname, navigate]);

  const handlePowerToggle = () => {
    if (!powerOn) {
      setFlicker(true);
      setTimeout(() => setFlicker(false), 600);
    }
    setPowerOn(!powerOn);
  };

  const handleKnobTurn = (path) => {
    navigate(path);
  };

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/bio", label: "Bio" },
    { path: "/media", label: "Media" },
    { path: "/headshots", label: "Headshots" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <div className="tv-wrapper">
      <img src={logo} alt="Logo" className="site-logo" onClick={() => navigate("/")} />
      <div className="tv-column">
      <div className="tv-frame">
        <img
          src={require("./image1.png")}
          alt="Retro TV"
          className="tv-image"
        />
        <div className={`tv-screen ${powerOn ? "on" : "off"} ${flicker ? "flicker" : ""}`}>
          {powerOn && (
            <div className="tv-content">
              <Outlet />
            </div>
          )}
        </div>
        <div className="tv-controls">
          <div className="knobs">
            <button onClick={handlePowerToggle} className="power-button">
              {powerOn ? "Turn Off" : "Turn On"}
            </button>
            {navItems.map((item) => (
              <button
                key={item.path}
                className="power-button"
                onClick={() => handleKnobTurn(item.path)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="tv-bottom-row">
        <div className="tv-promo-row">
          <Link
            to="/thunder-writer"
            className={`thunder-banner ${location.pathname === "/thunder-writer" ? "active" : ""}`}
          >
            <img
              src={`${process.env.PUBLIC_URL}/thunder-writer/logo-192.webp`}
              alt=""
              width="192"
              height="192"
              className="thunder-banner-logo"
            />
            {/* name first for screen readers; CSS shows the tag above it */}
            <span className="thunder-banner-copy">
              <span className="thunder-banner-text">Thunder Writer</span>
              <span className="thunder-banner-tag">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M13.5 2 4.5 13.5h6.5L10 22l9.5-12H13l.5-8Z" fill="currentColor" />
                </svg>
                Just released
              </span>
            </span>
            <span className="thunder-banner-arrow" aria-hidden="true">&rarr;</span>
          </Link>
          <button
            type="button"
            className={`book-banner ${location.pathname === "/book" ? "active" : ""}`}
            onClick={() => navigate("/book")}
          >
            <span className="book-banner-tag">New</span>
            <span className="book-banner-text">Book a 1:1 AI session</span>
            <span className="book-banner-arrow">&rarr;</span>
          </button>
        </div>
        <a
          href="https://www.tiktok.com/@marcthecs"
          target="_blank"
          rel="noopener noreferrer"
          className="tiktok-banner"
        >
          <span className="tiktok-banner-text">Find me on</span>
          <svg
            className="tiktok-banner-logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            fill="none"
          >
            <path d="M34.1451 0H26.0556V32.6956C26.0556 36.5913 22.9444 39.7913 19.0725 39.7913C15.2007 39.7913 12.0894 36.5913 12.0894 32.6956C12.0894 28.8696 15.1311 25.7391 18.8637 25.6V17.3913C10.6348 17.5304 4 24.2783 4 32.6956C4 41.1826 10.7741 48 19.1421 48C27.5101 48 34.2842 41.1131 34.2842 32.6956V15.9304C37.3259 18.1565 41.0585 19.4782 45 19.5478V11.3391C38.9157 11.0609 34.1451 6.0521 34.1451 0Z" fill="white"/>
          </svg>
        </a>
      </div>
      </div>
      {/* Mobile Navigation */}
      <nav className="mobile-nav">
        <button
          onClick={handlePowerToggle}
          className={!powerOn ? "power-off-pulse" : ""}
        >
          {powerOn ? "Off" : "On"}
        </button>
        {navItems.map((item) => (
          <button
            key={item.path}
            className={powerOn && location.pathname === item.path ? "active" : ""}
            onClick={() => handleKnobTurn(item.path)}
            disabled={!powerOn}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
